var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{staticClass:"view-page-login",attrs:{"limit":"small"}},[_c('blank-state',{attrs:{"title":"You're not logged in"}},[_c('a',{attrs:{"href":_vm.loginPath}},[_vm._v("Log in")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a591826","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/PageLogin.vue
// module id = 347
// module chunks = 0